import { createCustomSelector } from '../../domain/utils/react-reselect'
import { ROUTE_ITINERARY_COMPUTING, ROUTE_ITINERARY_RESULTS_BY_PROVIDER } from '../../routes'
import { selectCurrentHistoryRoute, selectCurrentHistoryRouteOptions } from '../history/history.selectors'
import { selectCurrentProvider } from '../itinerary/itinerary.selectors'
import { PROVIDER_TRAIN } from '../itinerary/itinerary.constants'

export const selectShouldAvoidSendPageTag = createCustomSelector(
  selectCurrentHistoryRoute,
  selectCurrentHistoryRouteOptions,
  selectCurrentProvider,
  (route, routeOptions, provider) =>
    routeOptions?.avoidSendPageTag ||
    route === ROUTE_ITINERARY_COMPUTING ||
    (route === ROUTE_ITINERARY_RESULTS_BY_PROVIDER && provider !== PROVIDER_TRAIN)
)
